import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { SettingField } from "@/components/settings/setting-field";
import { FormControl, FormField, FormItem, FormMessage } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { OnlineBookingConfig } from "../hooks/use-online-booking-config";

export function BookingSlotsConfig() {
  const { control } = useFormContext<OnlineBookingConfig>();
  const { t } = useTranslation("settings");

  return (
    <div className="space-y-4">
      <FormField
        control={control}
        name="slotsPerHour"
        rules={{
          required: t("bookingSettings.slotsPerHourRequired"),
          min: { value: 1, message: t("bookingSettings.minSlotsPerHour") },
          max: { value: 12, message: t("bookingSettings.maxSlotsPerHour") },
        }}
        render={({ field }) => (
          <FormItem>
            <SettingField
              label={t("onlineBooking.fields.slotsPerHour.label")}
              helpText={t("onlineBooking.fields.slotsPerHour.helpText")}
              helpDetails={
                <div className="space-y-2">
                  <div className="text-sm font-medium text-foreground">
                    {t("onlineBooking.fields.slotsPerHour.helpDetails.title")}
                  </div>
                  <ul className="text-sm space-y-1 text-muted-foreground">
                    {(
                      t("onlineBooking.fields.slotsPerHour.helpDetails.benefits", {
                        returnObjects: true,
                      }) as string[]
                    ).map((benefit: string, index: number) => (
                      <li key={index}>• {benefit}</li>
                    ))}
                  </ul>
                </div>
              }
            >
              <div className="flex items-center gap-2">
                <FormControl>
                  <Input
                    type="number"
                    min="1"
                    max="12"
                    className="w-24"
                    {...field}
                    onChange={(e) => field.onChange(Number.parseInt(e.target.value, 10) || 1)}
                  />
                </FormControl>
                <span className="text-sm text-muted-foreground">
                  {t("onlineBooking.slotsPerHour")}
                </span>
              </div>
            </SettingField>
            <FormMessage />
          </FormItem>
        )}
      />
    </div>
  );
}
